export const CONFIRMED_GET_CANDIDATES =
  "[Post Action] Confirmed Get Candidates";
export const GET_CANDIDATES_START =
  "[Get Action] Get Candidates start";
  export const CONFIRMED_GET_CANDIDATE =
  "[Post Action] Confirmed Get Candidate";
  export const CONFIRMED_GET_CANDIDATE_JOB =
  "[Post Action] Confirmed Get Candidate Job";
export const GET_CANDIDATE_FAILED_ACTION = "[Get Action] Get Candidate failed";
export const ADD_CANDIDATE_SUCCESS = "[Post Action] Add Candidate success";
export const ADD_CANDIDATE_FAILED = "[Post Action] Add Candidate failed";
export const UPDATE_CANDIDATE_SUCCESS = "[Put Action] Update Candidate success";
export const UPDATE_CANDIDATE_FAILED = "[Put Action] Update Candidate failed";
